import React from 'react';
import PropTypes from 'prop-types';
import { ChatSmile as IconChat } from 'common/components/svgs';
import { fireCustomEvent } from '~helpers/custom-events';
import { sendClickedLiveChatIconTrack } from './live-chat-track';

export default class MsgCenterIcon extends React.Component {
  componentDidMount() {
    fireCustomEvent('setupModalTriggers', { types: ['messageCenter'] });
    fireCustomEvent('msgCenterRenderUnreadMsg', { from: 'dashboard' });

    window.__MESSAGE_CENTER_ICON_LOADED__ = true;
  }

  handleClickMessageCenterButton = () => {
    this.props.onClick?.();
    sendClickedLiveChatIconTrack();
  };

  render() {
    return (
      <span
        className="dashboard__message-center-button js-account-modal-contact-host"
        onClick={this.handleClickMessageCenterButton}
      >
        <span className="live-chat__unread-count dashboard__unread-count"></span>
        <IconChat className="dashboard__message-center-icon" />
      </span>
    );
  }
}

MsgCenterIcon.propTypes = {
  onClick: PropTypes.func,
};
